import React from "react";
import MessageItem from "./MessageItem";

function ChatMessages({ chatMessages, isCompleted, profile, onTypingComplete }) {
    if (!chatMessages || chatMessages.length === 0) return null;

    return (
        <>
            {chatMessages.map((msg) => (
                <MessageItem 
                    key={msg.id} 
                    msg={msg} 
                    profile={profile}
                    onTypingComplete={onTypingComplete}
                />
            ))}
        </>
    );
}

export default ChatMessages;